<template>
  <div class="page-container">
    <div class="main">
      <!-- <div class="top">
        <h3 class="intro-txt">{{ $route.name }}</h3>
      </div> -->

      <page :url="url" :form="form">
        <template slot="tableSearch">
          <el-form-item label="系统名称">
            <el-input
              v-model="form.systemName"
              placeholder="系统名称"
            ></el-input>
          </el-form-item>
        </template>

        <template slot="buttonArea">
          <el-button type="primary" @click="add" size="small"
            >添加系统</el-button
          >
        </template>

        <template slot="tableColumn">
          <el-table-column prop="id" label="系统编号" align="center">
          </el-table-column>
          <el-table-column prop="systemName" label="所属系统" align="center">
          </el-table-column>
          <el-table-column
            prop="isLocked"
            label="是否锁定"
            :formatter="$formatter.formatBoolean"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            :formatter="$formatter.formatDate"
            align="center"
            width="200px"
          >
          </el-table-column>
          <el-table-column prop="createUser" label="创建人" align="center">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="220"
            align="center"
          >
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="edit(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                size="small"
                @click="deleteSystem(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </template>
      </page>

      <system-edit
        :show.sync="showDialog"
        :formData="formData"
        :action="action"
      ></system-edit>
    </div>
  </div>
</template>

<script>
import Page from "@/components/Page.vue";
import SystemEdit from "@/components/auth/SystemEdit.vue";

export default {
  name: "Systems",
  components: {
    page: Page,
    "system-edit": SystemEdit,
  },
  data() {
    return {
      url: "/sysSystemInfo/selectSystems",
      action: "",
      form: {
        systemName: "",
      },
      showDialog: false,
      formData: null,
    };
  },
  methods: {
    add() {
      this.action = "addSystem";
      this.formData = null;
      this.showDialog = true;
    },
    edit(row) {
      this.action = "editSystem";
      this.formData = row;
      this.showDialog = true;
    },
    deleteSystem(row) {
      this.$notify.error({
        title: "提示",
        message: "您不能删除此系统",
      });

      // this.$confirm('确认要删除系统【'+row.systemName+'】吗？', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      // }).then(() => {
      //     this.axios.post("/api/sysUserInfo/deleteUser",{id:row.id}).then(res=>{
      //         if (res.code === 200){
      //             this.$bus.$emit('refresh'); //通知刷新
      //             this.$notify({
      //                 title: '提示',
      //                 message: res.msg,
      //                 type: 'success'
      //             });
      //         }else{
      //             this.$notify.error({
      //                 title: '提示',
      //                 message: res.msg
      //             });
      //         }
      //     })
      // }).catch(() => {
      //
      // });
    },
  },
};
</script>

<style scoped>
</style>